import React, { useEffect } from 'react';

const HelpScoutClientBeacon = ({isOpen}) => {
  useEffect(() => {
    (function (e, t, n) {
      function a() {
        var e = t.getElementsByTagName("script")[0],
          n = t.createElement("script");
        n.type = "text/javascript";
        n.async = true;
        n.src = "https://beacon-v2.helpscout.net";
        e.parentNode.insertBefore(n, e);
      }
      if (e.Beacon = n = function (t, n, a) {
        e.Beacon.readyQueue.push({ method: t, options: n, data: a });
      }, n.readyQueue = [], "complete" === t.readyState) return a();
      e.attachEvent ? e.attachEvent("onload", a) : e.addEventListener("load", a, false);
    })(window, document, window.Beacon || function () { });

    window.Beacon('init', 'b246bdb5-98e4-450b-92b0-28bb605ac4f9');
    return () => {
      window.Beacon('destroy');
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      window.Beacon('open');
    } else {
      window.Beacon('close');
    }
  }, [isOpen]);

  return null;
};

export default HelpScoutClientBeacon;
